module.exports = __webpack_public_path__ + "static/media/kar2.a3e0809b.png";